<template src='./buttonSearch.pug' lang='pug'></template>

<script>
import ButtonPrimary from '../buttonPrimary/ButtonPrimary'

export default {
  name: 'ButtonSearch',

  components: {
    ButtonPrimary
  },

  props: {
    isDisabled: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style>
.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// ButtonSearch.vue?626445fe